var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0654 22.0651L16.549 16.5488L11.0327 22.0651",
    stroke: "white",
    strokeWidth: 1.37908,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5488 16.5488V28.9606",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1193 25.3613C29.4644 24.628 30.5269 23.4676 31.1393 22.0634C31.7517 20.6591 31.879 19.0909 31.5011 17.6063C31.1232 16.1217 30.2617 14.8051 29.0525 13.8645C27.8433 12.9239 26.3553 12.4127 24.8233 12.4117H23.0857C22.6682 10.7971 21.8902 9.29822 20.8101 8.02761C19.73 6.75701 18.3759 5.7478 16.8496 5.07585C15.3233 4.4039 13.6645 4.0867 11.998 4.14811C10.3315 4.20951 8.70056 4.64791 7.22786 5.43035C5.75515 6.21279 4.47898 7.31892 3.4953 8.66556C2.51162 10.0122 1.84602 11.5643 1.54853 13.2052C1.25105 14.8461 1.32943 16.5331 1.77778 18.1394C2.22613 19.7457 3.03279 21.2294 4.1371 22.479",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0654 22.0651L16.549 16.5488L11.0327 22.0651",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.68d002b208a77a9aa6aab0c9e96b1719.svg";
export { ForwardRef as ReactComponent };